import { render, staticRenderFns } from "./accessibility-modal-window.vue?vue&type=template&id=04be35e9"
import script from "./accessibility-modal-window.vue?vue&type=script&lang=js"
export * from "./accessibility-modal-window.vue?vue&type=script&lang=js"
import style0 from "./accessibility.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports